/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fleet_Filter_StoppedInputs */

const vi_fleet_filter_stopped = /** @type {(inputs: Fleet_Filter_StoppedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang dừng`)
};

/**

* @param {Fleet_Filter_StoppedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const fleet_filter_stopped = /** @type {((inputs?: Fleet_Filter_StoppedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fleet_Filter_StoppedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_fleet_filter_stopped(inputs)
});